const cutCosmosAddress = (wallet) =>
  wallet.substring(0, 10) + '...' + wallet.substring(wallet.length - 4, wallet.length);

export default cutCosmosAddress;
